import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface SourceNavigationRequest {
  label: string;
  pageNum: string;
}

@Injectable({ providedIn: 'root' })
export class SourceNavigationService {
  private readonly navigationSubject = new Subject<SourceNavigationRequest>();
  readonly navigation$ = this.navigationSubject.asObservable();

  navigate(label: string, pageNum: string): void {
    this.navigationSubject.next({ label, pageNum });
  }
}
